<template>
    <nav class="home-nav">
        <div class="nav-btn" :class="{ 'active':  NAVBTN_ACTIVED}" @click="navToggle">
            <span></span>
            <span></span>
            <span></span>
        </div>

        <transition name="page-nav">
            <nav class="page-nav-box" v-show="NAVBTN_ACTIVED">
                <ul class="page-nav-ul">
                    <li class="page-nav-li" 
                    :class="{'actived': NAV_ACTIVE_INDEX == index+1}"
                    v-for="(item, index) in navlist"
                    :key="`nav-li-${index}`"
                    @click="goTo(index, item.router_path, item.blank)"
                    >
                        <!-- <div class="nav-li-bg">
                            <p>{{ item.text }}</p>
                        </div> -->
                        <div class="nav-li-box">
                            <div class="nav-li-slide"></div>
                            <div class="nav-li-title">
                                <p>{{ item.text }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </nav>
        </transition>
    </nav>
</template>

<script>
export default {
    name: "home-nav",
    props: {
        isJump: {
            type: Boolean,
            default: false
        }
    },
    components: {

    },
    data: () => ({
        navlist: [
            {
                text: "HOME"
            },
            {
                text: "NEWS"
            },
            // {
            //     text: "CLUES"
            // },
            {
                text: "CHARACTER"
            },
            {
                text: "SYSTEM"
            },
            {
                text: "GALLERY"
            },
            {
                text: "COMMUNITY"
            },
            {
                text: "SPECIAL",
                router_path: '/fankit',
            }
        ]
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {
        NAVBTN_ACTIVED() {
            return this.$store.state.NAVBTN_ACTIVED;
        },
        HOME_FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        },
        NAV_ACTIVE_INDEX() {		// 导航栏激活指数
            if(this.$store.state.HOME_FULLPAGE) {       // 异步对象
                return this.$store.state.HOME_FULLPAGE.activeIndex;
            } else {
                return -1;
            }
        },
    },
    methods: {
        navToggle() {
            this.$store.commit("SET_NAVBTN_ACTIVED", !this.NAVBTN_ACTIVED)
        },
        goTo(index, router_path, blank) {
            // 页签导航
            if(router_path) {
                if(!blank) {
                    this.$router.push({ path: router_path })
                    this.$store.commit("SET_NAVBTN_ACTIVED", false);
                } else {
                    this.$store.commit("SET_NAVBTN_ACTIVED", false);
                    window.open(router_path, "_blank")
                }
            } else if(this.isJump) {
                this.$router.push({ name: 'home', params: { 'navIndex':index } })
            } else {
                this.HOME_FULLPAGE.goTo(index+1)
                this.$store.commit("SET_NAVBTN_ACTIVED", false);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.home-nav {
    position: relative;
    .nav-btn {
        width: pxTorem(32px);
        height: pxTorem(32px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        cursor: pointer;

        &.active {
            span {
                &:nth-of-type(1) {
                    transform: translate(pxTorem(-6px), pxTorem(12px)) rotate(45deg);
                }
                &:nth-of-type(2) {
                    opacity: 0;
                }
                &:nth-of-type(3) {
                    transform: translate(pxTorem(4px), pxTorem(12px)) rotate(-45deg);
                }
            }
        }

        span {
            flex-grow: 0;
            width: 100%;
            height: pxTorem(3px);
            background: #fff;
            display: block;
            position: absolute;
            top: 50%;
            transition: all ease-in-out .3s;

            &:nth-of-type(1) {
                transform-origin: right center;
                transform: translate(0, pxTorem(-8px));
            }
            &:nth-of-type(3) {
                transform-origin: left center;
                transform: translate(0, pxTorem(8px));
            }
        }
    }
    .page-nav-box {
        width: pxTorem(280px);
        box-sizing: border-box;
        padding-left: pxTorem(17px);
        border-left: 2px solid #fff;
        position: absolute;
        top: 130%;
        left: 5%;

        .page-nav-ul {
            width: 100%;
            background: #000;
            box-sizing: border-box;
            border: 1px solid #101010;
            display: flex;
            flex-direction: column;
            padding: pxTorem(40px) 0;

            .page-nav-li {
                display: block;
                width: 100%;
                height: pxTorem(40px);
                position: relative;
                // background: lightblue;

                &:not(:last-child) {
                    margin-bottom: pxTorem(60px);
                }

                &.actived {
                    .nav-li-slide {
                        flex: 1;
                    }
                    .nav-li-bg {
                        
                    }
                } 

                &:hover {
                    .nav-li-slide {
                        flex: 1;
                    }
                }         

                .nav-li-bg {
                    display: block;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;

                    p {
                        color: #171818;
                    }
                }
                
                .nav-li-box {
                    width: 90%;
                    height: 100%;
                    display: flex;
                    position: absolute;
                    justify-content: flex-start;
                    align-items: center;
                    cursor: pointer;

                    .nav-li-slide {
                        height: pxTorem(5px);
                        background: #22bbff;
                        transition: all .3s;
                    }
                    .nav-li-title {
                        margin-left: pxTorem(10px);
                        p {
                            color: #fff;
                            font-size: pxTorem(16px);
                        }
                    }
                }
            }
        }
    }
}

.page-nav-enter-active, .page-nav-leave-active {
    transition: all .5s;
}
.page-nav-enter, .page-nav-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}
</style>
